// Feature Configurations
import { FeatureConfiguration } from '../Types/FeatureConfiguration';

function useGetNestedRoutes(featureConfigurations: FeatureConfiguration[]): FeatureConfiguration[] {
    const flattenChildItems = (configs) =>
        configs.reduce((result, item) => {
            const navigationItem = item.navigationItem.route;
            if (navigationItem.childItems) {
                result.push(...navigationItem?.childItems);
                result.push(...flattenChildItems(navigationItem?.childItems));
            }
            return result;
        }, []);
    return flattenChildItems(featureConfigurations);
}

export default useGetNestedRoutes;
